export const checkInput = (event: KeyboardEvent) => {
  const target = event.target as HTMLInputElement;
  const currentValue = target.value || '';
  const key = event.key;

  // Allow special keys (backspace, delete, arrow keys, tab, etc.)
  const specialKeys = [
    'Backspace',
    'Delete',
    'ArrowLeft',
    'ArrowRight',
    'ArrowUp',
    'ArrowDown',
    'Tab',
    'Home',
    'End',
    'Enter',
  ];

  if (specialKeys.includes(key)) {
    return; // Allow special keys
  }

  // Allow digits (0-9) but only if there are less than 2 digits after decimal point
  if (/^\d$/.test(key)) {
    // Check if there's a decimal point and if there are already 2 digits after it
    if (currentValue.includes('.')) {
      const parts = currentValue.split('.');
      const decimalPart = parts[1] || '';
      // If there are already 2 or more digits after decimal, prevent more digits
      if (decimalPart.length >= 2) {
        event.preventDefault();
        return;
      }
    }
    return; // Allow digits
  }

  // Allow decimal point (.) but only if one doesn't already exist
  if (key === '.' && !currentValue.includes('.')) {
    return; // Allow decimal point if not already present
  }

  // Prevent all other keys
  event.preventDefault();
};
